module.exports = __webpack_public_path__ + "img/11.0ed56786.jpg";